import { Response } from "@/models/shared/Response";
import { PinValidationRequest } from "@/models/shared/PinValidationRequest";
import { PinValidationResponse } from "@/models/shared/PinValidationResponse";

export interface IPinValidationService {
  validate(
    pinValidation: PinValidationRequest,
    pinValidationUrl: string
  ): Promise<Response<PinValidationResponse>>;
  recover(
    pinValidationUrl: string
  ): Promise<Response<PinValidationResponse>>;
}

export class PinValidationService implements IPinValidationService {
  async validate(
    pinValidation: PinValidationRequest,
    pinValidationUrl: string
  ): Promise<Response<PinValidationResponse>> {
    const resp = await fetch(pinValidationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pinValidation),
    });
    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
  async recover(
    pinValidationUrl: string
  ): Promise<Response<PinValidationResponse>> {
    const resp = await fetch(pinValidationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        forgotPIN: true,
      }),
    });
    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const pinValidationService = new PinValidationService();
